
import { updateLearnerlogactivityDetails } from 'utils/gameApplication/gamePlayService';

export const incrementScenarioReplayCount = (
  scenarioName: any,
  questNo: number,
  replayType: 'mandatoryReplay' | 'optionalReplay' | 'replayPointPrompt' | any,
  setLearnerPlayingDetails: any,
  actionRef: any // 👈 new
) => {
  const actionKey = `${scenarioName}-${questNo}-${replayType}`;

  // 🛑 Prevent only duplicate render execution (NOT user clicks)
  if (actionRef.current === actionKey) {
    return;
  }

  actionRef.current = actionKey;

  setLearnerPlayingDetails((prev: any) => {
    const existingAttempts = Array.isArray(prev?.scenarioAttempts)
      ? [...prev.scenarioAttempts]
      : [];

    const questStr = `quest${questNo}`;

    const scenarioIndex = existingAttempts.findIndex(
      (att: any) =>
        att.quest === questStr && att.scenario === scenarioName
    );

    if (scenarioIndex >= 0) {
      const updated = { ...existingAttempts[scenarioIndex] };

      if (replayType === 'mandatoryReplay') {
        updated.mandatory_reply = (updated.mandatory_reply || 0) + 1;
      }

      if (replayType === 'optionalReplay') {
        updated.optional_reply = (updated.optional_reply || 0) + 1;
      }

      existingAttempts[scenarioIndex] = updated;
    } else {
      existingAttempts.push({
        quest: questStr,
        scenario: scenarioName,
        mandatory_reply: replayType === 'mandatoryReplay' ? 1 : 0,
        optional_reply: replayType === 'optionalReplay' ? 1 : 0,
        completed_count: 1
      });
    }

    return {
      ...prev,
      scenarioAttempts: existingAttempts
    };
  });

  // ✅ Reset after execution (allows next click)
  setTimeout(() => {
    actionRef.current = null;
  }, 0);
};

// export const logActivity = async (learnerActivityrec: any) => {
//   try {
   
//     const result = await updateLearnerlogactivityDetails({ rec: learnerActivityrec });
//     if (!result.success) {
//       console.error(result)
//     }

//   } catch (error) {
//     console.error(error)
//   }

// }

type ActivitySaveState = {
  inFlight: boolean;
  pendingPayload: any | null;
  timer: ReturnType<typeof setTimeout> | null;
};

const activitySaveStates = new Map<string, ActivitySaveState>();

const getActivityKey = (learnerActivityrec: any) => {
  const playerId =
    learnerActivityrec?.learnerdetails?.playerId ?? "unknown";

  const gameId =
    learnerActivityrec?.learnerdetails?.GameId ?? "unknown";

  return `${playerId}_${gameId}`;
};

const processActivitySave = async (key: string) => {
  const state = activitySaveStates.get(key);

  if (!state || state.inFlight || !state.pendingPayload) {
    return;
  }

  state.inFlight = true;

  // Take the latest payload
  const payload = state.pendingPayload;

  // Clear it before sending
  state.pendingPayload = null;

  try {
    const result = await updateLearnerlogactivityDetails({
      rec: payload,
    });

    if (!result?.success) {
      console.error(
        "learnerActivityDetails save failed:",
        result
      );
    }
  } catch (error) {
    console.error(
      "learnerActivityDetails request failed:",
      error
    );

    // Keep the payload so the latest state isn't lost
    if (!state.pendingPayload) {
      state.pendingPayload = payload;
    }
  } finally {
    state.inFlight = false;

    // If another update happened while this request was running,
    // send the latest payload after a small delay.
    if (state.pendingPayload) {
      setTimeout(() => {
        processActivitySave(key);
      }, 100);
    }
  }
};

export const logActivity = (learnerActivityrec: any) => {
  try {
    const key = getActivityKey(learnerActivityrec);

    let state = activitySaveStates.get(key);

    if (!state) {
      state = {
        inFlight: false,
        pendingPayload: null,
        timer: null,
      };

      activitySaveStates.set(key, state);
    }

    // Always keep only the latest activity state
    state.pendingPayload = learnerActivityrec;

    // Reset debounce timer
    if (state.timer) {
      clearTimeout(state.timer);
    }

    // Wait until activity changes settle down
    state.timer = setTimeout(() => {
      state!.timer = null;
      processActivitySave(key);
    }, 500);
  } catch (error) {
    console.error("logActivity error:", error);
  }
};

export const getDeviceInfo = async () => {
  let ipAddress = "";

  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    ipAddress = data.ip;
  } catch (error) {
    console.error("Unable to get IP Address", error);
  }

  const userAgent = navigator.userAgent;

  let browserName = "Unknown";

  if (userAgent.includes("Edg")) {
    browserName = "Microsoft Edge";
  } else if (userAgent.includes("Chrome")) {
    browserName = "Google Chrome";
  } else if (userAgent.includes("Firefox")) {
    browserName = "Mozilla Firefox";
  } else if (
    userAgent.includes("Safari") &&
    !userAgent.includes("Chrome")
  ) {
    browserName = "Safari";
  } else if (
    userAgent.includes("OPR") ||
    userAgent.includes("Opera")
  ) {
    browserName = "Opera";
  }

  return {
    ipAddress,
    userAgent,
    browserName
  };
};
// gameActivity
export const updateScreenActivity = (
  prev: any,
  screenId: number,
  screenName: string,
  deviceInfo:any,
  activityData: any = {}
) => {
  const now = Date.now();
  const currentTime = new Date(now).toISOString();
  let screenDetails = [
    ...(prev?.screendetails || [])
  ];
  // Close previous opened screen
  screenDetails = screenDetails.map((screen: any) => {
    if (
      screen.exitTime === null &&
      screen.screenId !== screenId
    ) {
      return {
        ...screen,
        exitTime: currentTime,
        durationInSeconds:
          Math.floor(
            (now - screen.enteredAtMilliseconds) / 1000
          )
      };
    }
    return screen;
  });
  // Check current screen already exists
  const currentScreenIndex =
    screenDetails.findIndex(
      (screen: any) =>
        screen.screenId === screenId &&
        screen.exitTime === null
    );
  // Existing screen update
  if (currentScreenIndex !== -1) {
    screenDetails[currentScreenIndex] = {
      ...screenDetails[currentScreenIndex],
      ...activityData
    };
  }
  else {
    // New screen create
    screenDetails.push({
      screenId,
      screenName,
      entryTime: currentTime,
      entryDate: currentTime,
      enteredAtMilliseconds: now,
      exitTime: null,
      durationInSeconds: 0,
      // Story blocks only
      ...deviceInfo,
      ...(screenId === 17 && {
        answers: [],
      }),
      ...activityData
    });
  }
  return {
    ...prev,
    screendetails: screenDetails
  };
};


// Story block tracking
export const createOrUpdateStoryBlock = (
  prev: any,
  blockData: any,
  deviceInfo:any
) => {

  const now = Date.now();
  const time = new Date(now).toISOString();

  const screens = [...prev.screendetails];

  const screenIndex = screens.findIndex(
    (item: any) => item.screenId === 2 && item.exitTime === null
  );

  if (screenIndex === -1) {
    return prev;
  }


  const screen = screens[screenIndex];


  let questNo = blockData?.blockQuestNo || 1;


  // Check scenario
  const hasScenario =
    blockData?.blockScenario !== null &&
    blockData?.blockScenario !== undefined &&
    blockData?.blockScenario !== "";


  let sectionKey = hasScenario
    ? `scenario${blockData.blockScenario}`
    : `quest${questNo}`;


  let sectionBlocks = [
    ...(screen[sectionKey] || [])
  ];


  // check existing active block
  const blockIndex = sectionBlocks.findIndex(
    (item: any) =>
      item.blockId === blockData.blockId &&
      item.exitTime === null
  );


  // Existing block update
  if (blockIndex !== -1) {

    sectionBlocks[blockIndex] = {

      ...sectionBlocks[blockIndex],

      blockdetails: {
        ...sectionBlocks[blockIndex].blockdetails,
        ...blockData
      }

    };

  }
  else {

    // close previous block in same section
    sectionBlocks =
      sectionBlocks.map((item: any) => {

        if (item.exitTime === null) {

          return {
            ...item,
            exitTime: time,
            durationInSeconds:
              Math.floor(
                (now - item.enteredAtMilliseconds) / 1000
              )
          }

        }

        return item;

      });



    // create new block

    sectionBlocks.push({

      blockId: blockData.blockId,

      blockdetails: blockData,

      entryTime: time,

      entryDate: time,

      enteredAtMilliseconds: now,

      exitTime: null,

      durationInSeconds: 0,
      ...deviceInfo,
      // only interaction
      ...(blockData.blockChoosen === "Interaction" && {
        optionschoose: []
      })

    });

  }



  screens[screenIndex] = {

    ...screen,

    [sectionKey]: sectionBlocks

  };


  return {

    ...prev,

    screendetails: screens

  };

};

export const updateInteractionBlock = (
  prev: any,
  data: any,
  deviceInfo:any,
) => {
  const screens =
    prev.screendetails.map((screen: any) => {
      if (screen.screenId !== 2) {
        return screen;
      }
      let updatedScreen = { ...screen };
      Object.keys(screen)
        .filter(key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
        )
        .forEach((section) => {
          updatedScreen[section] =
            screen[section].map((block: any) => {
              if (
                block.blockId === data.blockId &&
                block.exitTime === null
              ) {
                return {
                  ...block,
                  optionschoose: [
                    ...(block.optionschoose || []),
                    {
                      ...deviceInfo,
                      selectedoption: data.selectedoption,
                      score: data.score,
                      response: data.response,
                      feed: data.feed
                    }
                  ]
                };
              }
              return block;
            });
        });
      return updatedScreen;
    });
  return {
    ...prev,
    screendetails: screens
  };
}

export const updateReflectionBlock = (
  prev: any,
  data: any,
  deviceInfo:any,
) => {

  const screens =
    prev.screendetails.map((screen: any) => {

      if (screen.screenId !== 2) {
        return screen;
      }


      const updatedScreen = {
        ...screen
      };


      Object.keys(screen)
        .filter(key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
        )
        .forEach(section => {


          updatedScreen[section] =
            screen[section].map((block: any) => {


              if (
                block.blockId === data.blockId &&
                block.exitTime === null
              ) {

                return {

                  ...block,

                  answerdetails: {
                    ...deviceInfo,
                    answers: data.answers,

                    gameId: data.gameId,

                    questNo: data.questNo,

                    refansGameMode: data.refansGameMode,

                    blockSecondaryId: data.blockSecondaryId,

                    learnerId: data.learnerId

                  }

                };

              }


              return block;


            });


        });


      return updatedScreen;


    });


  return {

    ...prev,

    screendetails: screens

  };

};

export const updatePreAssessmentBlock = (
  prev: any,
  data: any,
  deviceInfo:any,
) => {
  const screens =
    prev.screendetails.map((screen: any) => {
      if (screen.screenId !== 2) {
        return screen;
      }
      const updatedScreen = {
        ...screen
      };
      Object.keys(screen)
        .filter(key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
        )
        .forEach(section => {
        updatedScreen[section] =
            screen[section].map((block: any) => {
              if (
                block.blockId === data.blockId &&
                block.exitTime === null
              ) {
                return {
                  ...block,
                  attempt: [
                    ...(block.attempt || []),
                    {
                      ...deviceInfo,
                      attempt: data.attempt,
                      transcript: data.transcript,
                      is_valid: data.is_valid,
                      validation_message: data.validation_message,
                      timestamp: new Date().toISOString()
                    }
                  ]
                };
              }
              return block;
            });
        });
      return updatedScreen;
    });
  return {
    ...prev,
    screendetails: screens
  };
}

export const updatePostAssessmentBlock = (
  prev: any,
  data: any,
  deviceInfo:any
) => {
const screens =
    prev.screendetails.map((screen: any) => {
      if (screen.screenId !== 2) {
        return screen;
      }
      const updatedScreen = {
        ...screen
      };
      Object.keys(screen)
        .filter(key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
        )
        .forEach(section => {
        updatedScreen[section] =
            screen[section].map((block: any) => {
              if (
                block.blockId === data.blockId &&
                block.exitTime === null
              ) {
                return {
                  ...block,
                    attempt:[
                      ...(block.attempt || []),
                      {
                        ...deviceInfo,
                        attempt:data.attempt,
                        transcript:data.transcript,
                        is_valid:data.is_valid,
                        validation_message:data.validation_message,
                        submittedAt:new Date().toISOString()
                      }
                    ],

                    ...(data.evaluation && {
                      evaluation:data.evaluation
                    })
                };
              }
              return block;
            });
        });
      return updatedScreen;
    });
  return {
    ...prev,
    screendetails: screens
  };

};


export const updateWeHaveChooseBlock = (
  prev: any,
  data: any,
  deviceInfo: any
) => {

  const screens = prev.screendetails.map((screen: any) => {
    if (screen.screenId !== 2) {
      return screen;
    }
    const updatedScreen = {
      ...screen
    };
    Object.keys(screen)
      .filter(
        key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
      )
      .forEach(section => {
        updatedScreen[section] =
          screen[section].map((block: any) => {
            if (
              block.blockId === data.blockId &&
              block.exitTime === null
            ) {
              let attempts = [...(block.attempt || [])];
              const attemptIndex = attempts.findIndex(
                (item: any) => item.attempt === data.attempt
              );
              // Existing attempt
              if (attemptIndex !== -1) {
                const currentAttempt = attempts[attemptIndex];
                attempts[attemptIndex] = {
                  ...currentAttempt,
                  ...(data.score !== undefined && {
                    score: data.score
                  }),
                  ...(data.finalscoreearned !== undefined && {
                    finalscoreearned: data.finalscoreearned
                  }),
                  ...(data.selectedOption !== undefined && {
                    answers: [
                      ...(currentAttempt.answers || []),
                      {
                        ...deviceInfo,
                        selectedOption: data.selectedOption,
                        selectedAnswer: data.selectedAnswer,
                        isCorrect: data.isCorrect,
                        submittedAt: new Date().toISOString()
                      }
                    ]
                  })
                };
              }
              else {
                attempts.push({
                  attempt: data.attempt,
                  score: data.score ?? 0,
                  finalscoreearned:
                    data.finalscoreearned ?? 0,
                  answers:
                    data.selectedOption !== undefined
                      ? [
                          {
                            ...deviceInfo,
                            selectedOption:
                              data.selectedOption,
                            selectedAnswer:
                              data.selectedAnswer,
                            isCorrect:
                              data.isCorrect,
                            submittedAt:
                              new Date().toISOString()
                          }
                        ]
                      : []
                });
              }
              return {
                ...block,
                attempt: attempts
              };
            }
            return block;
          });
      });
    return updatedScreen;
  });
  return {
    ...prev,
    screendetails: screens
  };
};


export const updateDragForNowBlock = (
  prev: any,
  data: any,
  deviceInfo: any
) => {
  const screens = prev.screendetails.map((screen: any) => {
    
    if (screen.screenId !== 2) {
      return screen;
    }
    const updatedScreen = {
      ...screen
    };
    Object.keys(screen)
      .filter(
        key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
      )
      .forEach(section => {
        updatedScreen[section] =
          screen[section].map((block: any) => {
            if (
              block.blockId === data.blockId &&
              block.exitTime === null
            ) {
              let attempts = [...(block.attempt || [])];
              const attemptIndex = attempts.findIndex(
                (item: any) => item.attempt === data.attempt
              );
              if (attemptIndex !== -1) {
                const currentAttempt = attempts[attemptIndex];
                attempts[attemptIndex] = {
                  ...currentAttempt,
                  ...(data.finalscoreearned !== undefined && {
                    finalscoreearned: data.finalscoreearned
                  }),
                  ...(data.score !== undefined && {
                    score: data.score
                  }),
                  ...(data.round !== undefined && {
                    rounds: [
                      ...(currentAttempt.rounds || []),
                      {
                        round: data.round,
                        score: data.score,
                        correctCount: data.correctCount,
                        totalCorrect: data.totalCorrect,
                        selectedItems: data.selectedItems,
                        submittedOrder: data.submittedOrder,
                        ...deviceInfo,
                        submittedAt: new Date().toISOString()
                      }
                    ]
                  })
                };
              } else {
                attempts.push({
                  attempt: data.attempt,
                  score: data.score ?? 0,
                  finalscoreearned:
                    data.finalscoreearned ?? 0,
                  rounds:
                    data.round !== undefined
                      ? [
                          {
                            round: data.round,
                            score: data.score,
                            correctCount: data.correctCount,
                            totalCorrect: data.totalCorrect,
                            selectedItems: data.selectedItems,
                            submittedOrder: data.submittedOrder,
                            ...deviceInfo,
                            submittedAt:
                              new Date().toISOString()
                          }
                        ]
                      : []
                });
              }
              return {
                ...block,
                attempt: attempts
              };
            }
            return block;
          });
      });
    return updatedScreen;
  });
  return {
    ...prev,
    screendetails: screens
  };
};
export const updateDragForNowBlockcategory = (
  prev: any,
  data: any,
  deviceInfo: any
) => {
  
  const screens = prev.screendetails.map((screen: any) => {
   
    if (screen.screenId !== 2) {
      return screen;
    }
    const updatedScreen = {
      ...screen
    };
    Object.keys(screen)
      .filter(
        key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
      )
      .forEach(section => {
        updatedScreen[section] =
          screen[section].map((block: any) => {
            if (
              block.blockId === data.blockId &&
              block.exitTime === null
            ) {
              let attempts = [...(block.attempt || [])];
              const attemptIndex = attempts.findIndex(
                (item: any) => item.attempt === data.attempt
              );
              if (attemptIndex !== -1) {
                const currentAttempt = attempts[attemptIndex];
                attempts[attemptIndex] = {
                  ...currentAttempt,
                  ...(data.finalscoreearned !== undefined && {
                    finalscoreearned: data.finalscoreearned
                  }),
                  ...(data.type !== undefined && {
                    type:data.type,
                  }),
                  ...(data.round !== undefined && {
                    rounds: [
                      ...(currentAttempt.rounds || []),
                      {
                        
                        round: data.round,
                        correctCount: data.correctCount,
                        answer: data.answer,
                        submittedAt: new Date().toISOString(),
                        ...deviceInfo,
                      }
                    ]
                  })
                };
              } else {
                attempts.push({
                  attempt: data.attempt,
                  type:data.type,
                  finalscoreearned:
                    data.finalscoreearned ?? 0,
                  rounds:
                    data.round !== undefined
                      ? [
                          {
                            round: data.round,
                            correctCount: data.correctCount,
                            answer: data.answer,
                            submittedAt:
                              new Date().toISOString(),
                              ...deviceInfo,
                          }
                        ]
                      : []
                });
              }
              return {
                ...block,
                attempt: attempts
              };
            }
            return block;
          });
      });
    
    return updatedScreen;
  });
  return {
    ...prev,
    screendetails: screens
  };
};

export const updateSwipeMiniGameBlock = (
  prev: any,
  data: any,
  deviceInfo: any
) => {

  const screens = prev.screendetails.map((screen: any) => {

    if (screen.screenId !== 2) {
      return screen;
    }

    const updatedScreen = {
      ...screen
    };


    Object.keys(screen)
      .filter(
        key =>
          key.startsWith("quest") ||
          key.startsWith("scenario")
      )
      .forEach(section => {

        updatedScreen[section] =
          screen[section].map((block: any) => {


            if (
              block.blockId === data.blockId &&
              block.exitTime === null
            ) {


              let attempts = [
                ...(block.attempt || [])
              ];


              const attemptIndex =
                attempts.findIndex(
                  (item:any)=>
                    item.attempt === data.attempt
                );


              // Existing attempt
              if(attemptIndex !== -1){

                const currentAttempt =
                  attempts[attemptIndex];


                attempts[attemptIndex] = {

                  ...currentAttempt,


                  ...(data.score !== undefined && {
                    score:data.score
                  }),


                  ...(data.finalscoreearned !== undefined && {
                    finalscoreearned:
                      data.finalscoreearned
                  }),


                  ...(data.selectedOption !== undefined && {

                    answers:[
                      ...(currentAttempt.answers || []),

                      {

                        ...deviceInfo,

                        round:
                          data.round,

                        statement:
                          data.statement,


                        selectedOption:
                          data.selectedOption,


                        correctOption:
                          data.correctOption,


                        isCorrect:
                          data.isCorrect,


                        submittedAt:
                          new Date().toISOString()
                      }
                    ]

                  })

                };

              }


              // First attempt
              else {

                attempts.push({

                  attempt:
                    data.attempt,


                  score:
                    data.score ?? 0,


                  finalscoreearned:
                    data.finalscoreearned ?? 0,


                  answers:
                    data.selectedOption !== undefined
                    ?
                    [
                      {

                        ...deviceInfo,

                        round:
                          data.round,

                        statement:
                          data.statement,


                        selectedOption:
                          data.selectedOption,


                        correctOption:
                          data.correctOption,


                        isCorrect:
                          data.isCorrect,


                        submittedAt:
                          new Date().toISOString()

                      }
                    ]
                    :
                    []

                });

              }


              return {

                ...block,

                attempt:attempts

              };

            }


            return block;

          });

      });


    return updatedScreen;

  });


  return {

    ...prev,

    screendetails:screens

  };

};